import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoEsquemasEsquemaComisionistasAgregarComponent {
  agregados
  onClose
  data = []
  filtro = ''
  resultados = []

  constructor (FanProyectoEsquemasComisionistasService, $filter) {
    this.FanProyectoEsquemasComisionistasService = FanProyectoEsquemasComisionistasService
    this.filterBy = $filter('filter')
  }

  $onInit () {
    this.$promise = this.FanProyectoEsquemasComisionistasService.get()
      .then(({data}) => {
        let seleccionados = this.agregados.map((item) => item.id_comisionista)
        this.data = data.filter((item) => !seleccionados.includes(item.id_comisionista))
        this.resultados = [...this.data]
      })
  }

  cancelar () {
    this.onClose({$event: {detail: null}})
  }

  filtrar () {
    this.resultados = this.filterBy(this.data, this.filtro)
  }

  seleccionar (item) {
    let detail = {
      nombre: item.nombre,
      id_comisionista: item.id_comisionista,
      comision_porcentaje: 0,
      master: false,
      notas: '',
    }

    this.onClose({$event: {detail}})
  }
}

module.component('fanProyectoEsquemasEsquemaComisionistasAgregar', {
  controller: FanProyectoEsquemasEsquemaComisionistasAgregarComponent,
  template,
  bindings: {
    agregados: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/esquemas/esquema/comisionistas/agregar/component.js